import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/influencer/:id',
  title: 'Editar influencer',
  endpoint: '/app/person',
}
